import { render, staticRenderFns } from "./addStoragelist.vue?vue&type=template&id=0974fcac&scoped=true"
import script from "./addStoragelist.vue?vue&type=script&lang=js"
export * from "./addStoragelist.vue?vue&type=script&lang=js"
import style0 from "./addStoragelist.vue?vue&type=style&index=0&id=0974fcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974fcac",
  null
  
)

export default component.exports